import useOpenedDialog from '../useOpenedDialog/useOpenedDialog';
function useIsOpenDialog(dialogId: string) {
    const openedDialog = useOpenedDialog();

    return openedDialog === dialogId;
}

export default useIsOpenDialog;